import { sv as reactsv } from '@ews/react-translations';

const sv = {
...reactsv
}
export default sv
